import React from 'react';
import { useDispatch } from "react-redux";
import { BodyRegular } from "../../../../atoms/fonts/Body";
import { SubHeaderContainer, SubHeaderContent, SubHeaderMenuItem } from "./ViewComponents";
import { TeamsHeaderComponents } from "../TeamsHeaderComponents";
import { redirectTo } from '@shared/store/auth.duck';
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

export function WhereaboutsSubHeader(props: Props) {
  const dispatch = useDispatch();
  const location = useLocation();
  const {t} = useTranslation();

  return (
    <SubHeaderContainer fullScreenView={props.fullScreenView}>
      <SubHeaderContent>
        <SubHeaderMenuItem selected={location.pathname.includes('/whereabouts/team')}
                           onClick={() => dispatch(redirectTo(`/whereabouts/team`))}>
          <BodyRegular weight={600}>{t('team-view.team-view')}</BodyRegular>
        </SubHeaderMenuItem>
        <SubHeaderMenuItem selected={location.pathname.includes('/whereabouts/work-planner')}
                           onClick={() => dispatch(redirectTo('/whereabouts/work-planner'))}>
          <BodyRegular weight={600}>{t('work-planner.work-planner')}</BodyRegular>
        </SubHeaderMenuItem>
        <SubHeaderMenuItem selected={location.pathname.includes('/whereabouts/floor-planner')}
                           onClick={() => dispatch(redirectTo('/whereabouts/floor-planner'))}>
          <BodyRegular weight={600}>{t('button.floor-plan')}</BodyRegular>
        </SubHeaderMenuItem>
        <SubHeaderMenuItem selected={location.pathname.includes('/whereabouts/office-view')}
                           onClick={() => dispatch(redirectTo('/whereabouts/office-view'))}>
          <BodyRegular weight={600}>{t('button.office-view')}</BodyRegular>
        </SubHeaderMenuItem>
        <TeamsHeaderComponents/>
      </SubHeaderContent>
    </SubHeaderContainer>
  )
}

interface Props {
  fullScreenView?: boolean;
}

